// extracted by mini-css-extract-plugin
export default {"textBox":"index_textBox__F7jdK","label":"index_label__JQ1xS","description":"index_description__zOo4J"};